module.exports = __webpack_public_path__ + "img/game1.1.1712b68c.png";